import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { recipesAdminAdminRouter } from './routing/recipesAdminAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { recipeAdminLibraryCsvIngestionAccessConfiguration } from './access-control/recipeAdminLibraryCsvIngestionAccess.configuration'
import { recipeAdminLibraryManagerAccessConfiguration } from './access-control/recipeAdminLibraryManagerAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'recipes-admin',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'recipes-admin-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [recipesAdminAdminRouter],
  },
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Merchandising,
      subNavItems: [
        {
          route: 'app-admin-recipes-admin-library-csv-ingestion',
          labelId: 'recipesAdminDomain.library.csv-ingestion',
          accessControl: recipeAdminLibraryCsvIngestionAccessConfiguration,
          positionNavV2: 1,
        },
        {
          route: 'app-admin-recipes-admin-library-manager',
          labelId: 'recipesAdminDomain.library.library-manager',
          accessControl: recipeAdminLibraryManagerAccessConfiguration,
          positionNavV2: 2,
        },
      ],
    },
  ],
}

export default definition
